import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import { IP } from "../config/IP";
import { initDocs } from "./getDocs";
import { initNotifications } from "./loadNotifications";
import { initializeUserStatus } from "./manageUserStatus";
import {
  APP_REGISTER_COMPLETED,
  APP_REGISTER_FAILED,
  APP_REGISTER_INIT,
  APP_REGISTER_LOADING,
  APP_SAVE_DEVICE_INFO,
  APP_SAVE_USER_INFO,
  APP_SAVE_USER_INFO_FAIL,
  APP_SAVE_USER_TOKEN,
  APP_SAVE_USER_TOKEN_FAILED,
  AUTH_ERROR,
  COMPANY_INIT,
  COMPANY_LOAD_INFO,
  LOGOUT_USER,
  OFFICE_LOAD_INFO,
  USER_LOADED,
  USER_LOADING,
  USER_UPDATE,
  SAVE_USER_PROFILE,
} from "./types";

export const updateUserProfile = (data) => (dispatch) => {
  dispatch({ type: SAVE_USER_PROFILE, payload: data });
};
export const updateUser = (data) => (dispatch) => {
  dispatch({ type: USER_UPDATE, payload: data });
};

export const userLoginFetch = (user) => {
  console.log("userLoginFetch user=", user);
  return (dispatch) => {
    dispatch({ type: USER_LOADING });
    return fetch(IP.nodeServer + "api/athenticate", {
      method: "POST",

      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log("userLoginFetch data=", data);
        if (data) {
          if (data.auth) {
            console.log("userLoginFetch data=" + data);
            localStorage.setItem("token", data.token);
            localStorage.setItem("currentUser=", data.user);
            dispatch(
              loadUser({
                ...data.user,
                companyData: { isSaved: false, selectedCompanyId: "" },
              })
            );
          } else {
            if (data.error) {
              throw new Error(data.error);
            } else {
              throw new Error("userLoginFetch Unkown error happen!");
            }
          }
        } else {
          throw new Error("userLoginFetch Unkown error happen!");
        }
      })
      .catch((err) => {
        console.log("userLoginFetch auth error err=", err);
        console.log("userLoginFetch auth error  err.stack=", err.stack);
        dispatch({ type: AUTH_ERROR, payload: err.message });
      });
  };
};

export const userRegisterFetch = (user) => {
  console.log("userRegisterFetch user", user);
  return (dispatch) => {
    return fetch(IP.nodeServer + "api/userRegister", {
      method: "POST",

      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        }
        throw new Error("Network response was not OK");
      })
      .then((data) => {
        console.log("data=", data);
        if (!data.auth) {
          // Here you should have logic to handle invalid login credentials.
          // This assumes your Rails API will return a JSON object with a key of
          // 'message' if there is an error
        } else {
          console.log("userRegisterFetch data=" + data);
          localStorage.setItem("token", data.token);
          localStorage.setItem("currentUser", data.user);
          dispatch(
            loadUser({
              ...data.user,
              companyData: { isSaved: false, selectedCompanyId: "" },
            })
          );
        }
      })
      .catch((err) => {
        dispatch({ type: AUTH_ERROR, payload: err.stack });
      });
  };
};

export const initUser = () => async (dispatch) => {
  let token = localStorage.getItem("token");
  let user = localStorage.getItem("myApp:user");
  let selectedCompanyId = localStorage.getItem("selectedCompanyId");

  await dispatch({
    type: APP_SAVE_USER_TOKEN,
    payload: token,
  });
};

export const loadUser = (info) => (dispatch) => {
  console.log("loadUser info=", info);
  try {
    dispatch({ type: USER_LOADING });
    dispatch({ type: COMPANY_INIT });
    dispatch({ type: APP_REGISTER_INIT });

    //const token = getState.token;
    //console.log("getState", getState);
    const token = localStorage.getItem("token");
    let selectedCompanyId = localStorage.getItem("selectedCompanyId");

    console.log("loadUser token=" + token);

    const config = { headers: { "Content-Type": "application/json" } };
    if (token) {
      config.headers["x-auth-token"] = token;

      console.log("loadUser config=", config);

      fetch(IP.nodeServer + "api/userProfile", {
        method: "POST",
        body: JSON.stringify(info ? info.companyData : {}),

        headers: config.headers,
      })
        .then((resp) => resp.json())
        .then((data) => {
          console.log("loadUser data=", data);
          dispatch({ type: USER_LOADED, payload: data });
          try {
            localStorage.setItem("myApp:user", JSON.stringify(data));
          }

          catch (error) {
            if (error instanceof DOMException && error.code === 22) {
              // Handle storage quota exceeded error
              if (data.image) {
                delete data['image'];
                localStorage.setItem("myApp:user", JSON.stringify(data));
              }
              console.error('Storage quota exceeded');
              // Perform necessary actions to free up storage or notify the user
            } else {
              // Handle other localStorage errors
              console.error('localStorage error:', error.message);
            }








          }
          let userInfo = data.allUser.find((x) => x._id === data.usernameId);
          console.log("loadUser userInfo=", userInfo);
          console.log("loadUser image=", data.image);

          localStorage.setItem(
            "selectedCompanyId",
            info.companyData.isSaved
              ? info.companyData.selectedCompanyId
              : selectedCompanyId
                ? selectedCompanyId
                : data.allCompanies.length > 0
                  ? data.allCompanies[0]._id
                  : ""
          );
          selectedCompanyId = localStorage.getItem("selectedCompanyId");
          console.log("loadUser selectedCompanyId storage=", selectedCompanyId);
          console.log(
            "loadUser selectedCompany found=",
            selectedCompanyId
              ? selectedCompanyId
              : data.allCompanies.length > 0
                ? data.allCompanies[0]._id
                : ""
          );

          dispatch({
            type: COMPANY_LOAD_INFO,
            payload: {
              allCompanies:
                data.allCompanies.length > 0 ? data.allCompanies : [],
              selectedCompanyId: selectedCompanyId
                ? selectedCompanyId
                : data.allCompanies.length > 0
                  ? data.allCompanies[0]._id
                  : "",
              office_id: userInfo
                ? userInfo.companies.length > 0
                  ? info.companyData.isSaved
                    ? userInfo.companies.filter(
                      (x) =>
                        x.companyId === info.companyData.selectedCompanyId
                    ).length > 0
                      ? userInfo.companies.find(
                        (x) =>
                          x.companyId === info.companyData.selectedCompanyId
                      ).office_id
                      : 0
                    : 0
                  : 0
                : 0,
            },
          });
          dispatch({
            type: OFFICE_LOAD_INFO,
            payload: { allOffice: data.allOffices, allUser: data.allUser },
          });

          dispatch(
            initializeUserStatus({
              status: userInfo,
              image: data.image,
              actingOfficeHierarchy: data.actingOfficeHierarchy,
            })
          );

          dispatch(initNotifications());
          dispatch(initDocs());

          storeNotification.addNotification({
            title: "Wonderful!",
            message: "Succefull UserProfile",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true,
            },
          });
        })
        .catch((err) => {
          console.log("loadUser auth actions err=", err);
          //dispatch(returnError(err.response.data, err.response.status));
          dispatch({ type: AUTH_ERROR, payload: err.stack });
        });
    } else {
      dispatch({
        type: AUTH_ERROR,
        payload: "No token provided",
      });
    }
  } catch (e) {
    console.log("loadUser error in loadUser e=", e);
    dispatch({
      type: AUTH_ERROR,
      payload: e,
    });
  }
};
export const registerAppUser = (listdata) => (dispatch) => {
  dispatch({ type: APP_REGISTER_LOADING });

  new Promise((resolve, reject) => {
    try {
      if (listdata.type === "save_email") {
        console.log("registerAppUser listdata=", listdata);
        const config = {
          headers: {
            "content-type": "application/json",
          },
        };
        axios
          .post(
            listdata.url,
            {
              action: listdata.action,
              email: listdata.email.toLowerCase(),
              deviceInfo: listdata.deviceInfo,
            },
            config
          )
          .then((response) => {
            if (response.status >= 400) {
              throw new Error(response.statusText);
            }

            console.log("registerAppUser=", response);
            if (listdata.action === "createOTP") {
              dispatch({ type: APP_REGISTER_INIT });
              if (response) {
                dispatch({
                  type: APP_SAVE_USER_INFO,
                  payload: {
                    email: listdata.email.toLowerCase(),
                    deviceInfo: listdata.deviceInfo,
                  },
                });
                return resolve();
              } else {
                dispatch({
                  type: APP_SAVE_USER_INFO_FAIL,
                  payload: { message: 'empty response', action: listdata.action },
                });
                return reject();
              }
            }
          })
          .catch((error) => {
            console.log("registerAppUser error 1=", (error.response && error.response.status === 400) ? error.response.data : error.message);

            return dispatch({
              type: APP_SAVE_USER_INFO_FAIL,
              payload: { message: (error.response && error.response.status === 400) ? error.response.data : error.message, action: listdata.action },
            });

          });
      }
      if (listdata.type === "confirm_otp") {
        dispatch({ type: APP_REGISTER_LOADING });

        console.log("registerAppUser listdata=", listdata);
        const config = {
          headers: {
            "content-type": "application/json",
          },
        };
        axios
          .post(
            listdata.url,
            {
              action: listdata.action,
              email: listdata.email.toLowerCase(),

              token: listdata.token,
            },
            config
          )
          .then(async (response) => {
            if (response.status >= 400) {
              throw response.statusText;
            }
            console.log("registerAppUser response.data=", response.data);

            if (response.data.isValid && !response.data.isExpired) {
              console.log(
                "registerAppUser response.data.token=",
                response.data.token
              );

              localStorage.setItem("token", response.data.token);
              console.log(
                "localStorage.getItem(token)=",
                localStorage.getItem("token")
              );

              await dispatch({
                type: APP_SAVE_USER_TOKEN,
                payload: response.data.token,
              });
              dispatch(
                loadUser({
                  auth: true,
                  message: "ok",
                  token: response.data.token,
                  companyData: { isSaved: false, selectedCompanyId: "" },
                })
              );

              return resolve();
            } else if (response.data.isValid && response.data.isExpired) {
              dispatch({
                type: APP_SAVE_USER_TOKEN_FAILED,
                payload: { message: "token Expired", action: listdata.action }
              });
              return resolve();
            } else {
              dispatch({
                type: APP_SAVE_USER_TOKEN_FAILED,
                payload: "Failed to verify token,Please try again",
              });
              return resolve();
            }
          })
          .catch((error) => {
            console.log("registerAppUser error 2=", error?.message);

            dispatch({
              type: APP_SAVE_USER_TOKEN_FAILED,
              payload: {
                message: "failed to verify OTP", action: listdata.action
              }
            });
            return resolve();
          });
      }
      if (listdata.type === "finilize") {
        dispatch({ type: APP_REGISTER_COMPLETED });
        return resolve();
      }
      if (listdata.type === "save_deviceInfo") {
        console.log("data.deviceInfo=", listdata.deviceInfo);
        dispatch({ type: APP_SAVE_DEVICE_INFO, payload: listdata.deviceInfo });
        return resolve();
      }
    } catch (e) {
      dispatch({ type: APP_REGISTER_FAILED });
      return resolve();
    }
  });
};
export const loadOffice = (listdata) => (dispatch) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      "x-auth-token": token,
      "content-type": "application/json",
    },
  };
  let inputs = {
    companyId: listdata.selectedCompanyId,
  };
  console.log("authActions loadOffice  inputs=", inputs);

  axios
    .post(IP.nodeServer + "api/officesByCompany", inputs, config)
    .then((response) => {
      console.log("authActions loadOffice response.data=", response.data);
      dispatch({
        type: OFFICE_LOAD_INFO,
        payload: {
          allOffice: response.data.AllOffice,
          allUser: response.data.allUser,
        },
      });
    })
    .catch((error) => {
      console.log("authActions loadOffice error=", error);
    });
};

export const logoutUser = () => (dispatch) => {
  //localStorage.removeItem("token");
  console.log("loadUser removing the token from the storage");
  dispatch({
    type: LOGOUT_USER,
    payload: null,
  });
  localStorage.setItem("token", null);
};
export const obscure_email = (email) => {
  var parts = email.split("@");
  var name = parts[0];
  var result = name.charAt(0);
  for (var i = 1; i < name.length; i++) {
    result += "*";
  }
  result += name.charAt(name.length - 1);
  result += "@";
  var domain = parts[1];
  result += domain.charAt(0);
  var dot = domain.indexOf(".");
  for (var i = 1; i < dot; i++) {
    result += "*";
  }
  result += domain.substring(dot);

  return result;
};
export const validate = (email) => {
  const expression =
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

  return expression.test(String(email));
};
export const validateNumber = (value) => {
  return /^[0-9]+$/.test(value);
};
export const validateEmail = (email) => {
  const expression =
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

  return expression.test(String(email));
};
export const dateIsValid = (dateStr) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (dateStr.match(regex) === null) {
    return false;
  }

  const date = new Date(dateStr);

  const timestamp = date.getTime();

  if (typeof timestamp !== "number" || Number.isNaN(timestamp)) {
    return false;
  }

  return date.toISOString().startsWith(dateStr);
};